import { ReactComponent as UnionIcon } from './union.svg';

export default UnionIcon;
